import httpClient from '@yola/http-client';
import actions from '../actions';

const fetchConfig = () => async (dispatch) => {
  try {
    const config = await httpClient.get('/static/config.json?c=1');
    dispatch(actions.setServiceConfig(config.data));
  } catch (error) {
    console.error('Failed to load config: ', error);
  }
};

export default fetchConfig;
